import { useEffect } from "react";

export default function SjAdminLoginPage() {
  useEffect(() => {
    window.document.location.assign("/sj-admin");
  }, []);
  return null;
}
